import React from 'react';
import type { FileContentBlock } from '../../store/chatStore';
import { MessageFileItem } from './MessageFileItem';

interface FileContentProps {
  content: FileContentBlock;
}

const getNameFromUrl = (urlString: string): string => {
  try {
    const url = new URL(urlString);
    const pathname = url.pathname;
    const lastSegment = pathname.split('/').filter(Boolean).pop() || '';
    return decodeURIComponent(lastSegment || 'file');
  } catch {
    // Fallback if invalid URL
    const parts = urlString.split('/');
    return decodeURIComponent(parts[parts.length - 1] || 'file');
  }
};

const getExtFromUrl = (urlString: string): string => {
  const name = getNameFromUrl(urlString);
  const dotIndex = name.lastIndexOf('.');
  return dotIndex !== -1 ? name.slice(dotIndex + 1).toLowerCase() : '';
};

export const FileContent: React.FC<FileContentProps> = ({ content }) => {
  const fileName = content?.metadata?.filename || getNameFromUrl(content.url);
  const ext = content?.metadata?.fileType || getExtFromUrl(content.url);
  const mimeType = content?.metadata?.fileType || `image/${ext}`;
  const isImage = [
    'jpg',
    'jpeg',
    'png',
    'gif',
    'webp',
    'bmp',
    'tiff',
    'svg',
  ].includes(ext);

  const handleDownload = () => {
    window.open(content.url, '_blank');
  };

  return (
    <MessageFileItem
      fileName={fileName}
      mimeType={mimeType}
      sizeBytes={content?.metadata?.fileSize || undefined}
      previewUrl={isImage ? content.url : undefined}
      onDownload={handleDownload}
    />
  );
};
